import styled, { css } from 'styled-components';
import { InputBaseCSS, InputLabelCSS, InputRequiredAsteriskCSS, InputWrapperCSS } from '../common/index.js';
export const InputLabel = styled.label `
  ${InputLabelCSS}
`;
export const RequiredAsterisk = styled(InputLabel) `
  ${InputRequiredAsteriskCSS}
`;
export const Input = styled.textarea `
  ${InputBaseCSS};
  padding: 10px 12px;
  height: 120px;
  resize: none;
  &:focus-within {
    border: 2px solid ${({ theme }) => theme.colors.AccentPurple};
    border-radius: 8px;
  }
  ${({ width }) => width &&
    css `
      width: ${width};
    `};
  ${({ height }) => height &&
    css `
      height: ${height};
    `};
`;
export const WordCount = styled.p `
  ${({ theme }) => theme.typography.Caption};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  margin-top: 4px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  ${({ theme, disabled }) => disabled &&
    css `
      color: ${theme.colors.TextDisabled};
    `}
  ${({ theme, error }) => error &&
    css `
      color: ${theme.colors.ErrorDefault};
    `}
`;
export const TextInputWrapper = styled.div `
  ${InputWrapperCSS}
`;
export const InputErrorMessage = styled.span `
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 14px;
  padding-left: 5px;
  line-height: 21px;
  margin-top: 8px;
  color: ${({ theme }) => theme.colors.ErrorDefault};
`;
//# sourceMappingURL=BKJTextArea.styled.js.map